import spanBlockMeta from './block.json';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';

import './style.scss';

import edit from './edit';
import save from './save';
import spanIcon from './icon';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = spanBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
  ...attributeClassDropDown,
};

registerBlockType(name, {
  ...settings,
  icon: spanIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
